import { render } from "./SectionList.vue?vue&type=template&id=1f2f2dc7"
import script from "./SectionList.vue?vue&type=script&lang=js"
export * from "./SectionList.vue?vue&type=script&lang=js"

import "./SectionList.vue?vue&type=style&index=0&id=1f2f2dc7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__